
import React from "react";
import ReactDOM from "react-dom/client";
import "@ant-design/v5-patch-for-react-19";
import "./index.css";
import "leaflet/dist/leaflet.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import { RouterProvider } from "react-router-dom";
import { ConfigProvider, theme as antdTheme } from "antd";
import fa_IR from "antd/locale/fa_IR";

import { AuthProvider } from "./provider/AuthProvider";
import { LayoutProvider } from "@/hook/useLayout";
import { ThemeProvider, useAppTheme } from "./provider/ThemeProvider";
import sentryInit from "@/lib/helper/sentry";
import ClarityIdentify from "@/lib/helper/clarity";
import router from "./router/router";
import Sockets from "@/lib/socket/Sockets";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 3,
        },
    },
});

sentryInit();

const darkColors = {
    colorBgBase: "#222B3D",
    colorBgContainer: "#313D52",
    colorBgElevated: "#445269",
};

const AppContent = () => {
    const { isDark } = useAppTheme();

    return (
        <ConfigProvider
            direction="rtl"
            locale={fa_IR}
            theme={{
                algorithm: isDark
                    ? antdTheme.darkAlgorithm
                    : antdTheme.defaultAlgorithm,
                token: {
                    fontFamily: "PeydaWebFaNum",
                    ...(isDark ? darkColors : {}),
                },
            }}
        >
            <React.StrictMode>
                <QueryClientProvider client={queryClient}>
                    <ToastContainer
                        rtl
                        position="bottom-left"
                        toastClassName="rounded-lg text-sm shadow-none"
                        bodyClassName="flex items-start"
                        icon
                    />

                    <LayoutProvider>
                        <AuthProvider>
                            <ClarityIdentify />
                            <RouterProvider router={router} />
                            <Sockets />
                        </AuthProvider>
                    </LayoutProvider>
                </QueryClientProvider>
            </React.StrictMode>
        </ConfigProvider>
    );
};

const App = () => (
    <ThemeProvider>
        <AppContent />
    </ThemeProvider>
);

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
